import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
    host:string = 'https://bitte.app:8080';
    //host:string = 'http://127.0.0.1:8000';
    port:string = '';
}